import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function PrivacyPolicy() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
            <div className="bg-white max-w-4xl w-full rounded-2xl shadow-xl p-10 animate-fade-in relative">
                <button
                    onClick={() => navigate(-1)}
                    className="absolute top-6 right-6 text-gray-400 hover:text-blue-600 transition-colors"
                >
                    <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                </button>

                <h1 className="text-4xl font-bold text-gray-800 mb-6 border-b pb-4">Privacy Policy</h1>
                <p className="text-sm text-gray-500 mb-8">Last Updated: December 2025</p>

                <div className="space-y-8 text-gray-700 leading-relaxed">
                    <section>
                        <h2 className="text-2xl font-bold text-gray-800 mb-3">1. Data We Collect</h2>
                        <p>We believe in minimal data collection. We only store:</p>
                        <ul className="list-disc ml-6 mt-2 space-y-1">
                            <li><strong>Account Info:</strong> Your username, email address, and profile picture.</li>
                            <li><strong>Encrypted Data:</strong> Your messages and files are stored in an encrypted format.</li>
                            <li><strong>Device Keys:</strong> Public keys needed to facilitate secure communication.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-800 mb-3">2. End-to-End Encryption</h2>
                        <p>We take your privacy seriously. All your communications are secured:</p>
                        <ul className="list-disc ml-6 mt-2 space-y-1">
                            <li><strong>Zero-Knowledge:</strong> Your messages and files are encrypted on your device <em>before</em> they leave your phone or computer.</li>
                            <li><strong>No One Can Read Them:</strong> Because we do not have your private decryption keys, <strong>we cannot read your messages or view your files.</strong></li>
                            <li><strong>Key Security:</strong> Your private key is encrypted with your own password. We cannot unlock it without your password.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-800 mb-3">3. File Storage Security</h2>
                        <p>
                            Files (photos, videos, documents) shared on our platform are also protected by strong encryption. They are uploaded to our secure cloud storage providers in an encrypted state.
                            Since only you and the recipient possess the keys to decrypt these files, they remain completely private and inaccessible to unauthorized parties, including system administrators.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-800 mb-3">4. Third-Party Services</h2>
                        <p>We use trusted third-party cloud providers to ensure the reliability and speed of our service. These providers host our encrypted data but have no ability to decrypt or access your personal information.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-800 mb-3">5. Your Control</h2>
                        <p>You have full control over your account. You can request account deletion at any time, which will remove your profile, keys, and encrypted data from our servers.</p>
                    </section>
                </div>

                <div className="mt-10 pt-6 border-t border-gray-100 text-center">
                    <button
                        onClick={() => navigate(-1)}
                        className="inline-block bg-blue-600 text-white font-bold py-3 px-8 rounded-full hover:bg-blue-700 transition-transform hover:scale-105 shadow-lg"
                    >
                        Agree & Join ChatIQ
                    </button>
                </div>
            </div>
        </div>
    );
}
